import { render, staticRenderFns } from "./hero.global.vue?vue&type=template&id=74b609fb&"
import script from "./hero.global.vue?vue&type=script&lang=js&"
export * from "./hero.global.vue?vue&type=script&lang=js&"
import style0 from "./hero.global.vue?vue&type=style&index=0&id=74b609fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports